/**
 * Returns a validated { lat, lon } location if both coordinates are finite.
 * Returns null otherwise.
 *
 * @param {{ lat?: number | null; lon?: number | null } | null | undefined} location
 * @returns {{ lat: number; lon: number } | null}
 */
export const getValidatedPinLocation = (location) => {
    if (location?.lat == null || location?.lon == null) {
        return null;
    }
    if (!Number.isFinite(location.lat) || !Number.isFinite(location.lon)) {
        return null;
    }
    return { lat: location.lat, lon: location.lon };
};
